import {getBaseURL, getAuthorizationHeader, getAppPrefix} from './utils';
import {getSubject} from '../oidcService';
import {isOpenidLogin} from '../proto/core/loginProps';
import {getWcfLogin} from '../../_shared/GWTBridge/invoke/genPage';
import {getLoginEmail} from '../../_shared/GWTBridge/invoke/common';
import {getUsername} from '../../_shared/GWTBridge/invoke/genPage';

const service = 'userconsent';
const getPostRequestOptions = (data, prefix) => ({
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        Authorization: getAuthorizationHeader(),
        prefix
    },
    body: JSON.stringify(data)
});
export const basicPOST = async <R>(data: any, prefix: string, action: string): Promise<R> => {
    return fetch(
        `${getBaseURL()}/webui/${prefix}/${service}/${action}`,
        getPostRequestOptions(data, prefix)
    )
        .then(res => {
            return res.json();
        })
        .then(data => data);
};

export const setUserConsent = async (type: number, content: string) => {
    const prefix = getAppPrefix().toLowerCase();
    const userName = getUsername();
    const userEmail = getLoginEmail();
    let subject = '';
    if (isOpenidLogin()) {
        subject = await getSubject();
    } else {
        subject = getWcfLogin();
    }
    const payload = {
        prefix,
        type,
        content,
        subject,
        userName,
        userEmail
    };
    try {
        await basicPOST(payload, prefix, 'set');
    } catch (err) {
        console.log('An error occurred trying to set user consent');
    }
};
